<template>
  <div
    ref="container"
    class="smart-recruiters-filter"
  >
    <select-fi
      ref="select"
      :name="name"
      :open="isActive"
      :disabled="options.length === 0"
      :elements="transformedOptions"
      :chevron-open="icon"
      :chevron-closed="icon"
      large-from="lg"
      no-mobile-selection
      @toggle-open="toggle"
      @change="newChange"
    >
      <simple-multiselect-options-fi
        :name="name"
        :options="transformedOptions"
        @select-changed="newChange"
        @close="close"
      />
    </select-fi>
  </div>
</template>

<script setup lang="ts">
import { SelectFi, SimpleMultiselectOptionsFi } from 'atoms';
import { computed, ref } from 'vue';

defineOptions({ name: 'SmartRecruitersFilter' });

const props = withDefaults(
  defineProps<{
    modelValue: any[];
    name?: string;
    options: any[];
    icon?: string;
  }>(),
  {
    name: 'Name',
    icon: undefined,
  },
);

const emit = defineEmits<{
  change: [values: any[]];
}>();

const isActive = ref(false);

const transformedOptions = computed(() =>
  props.options.map((option) => ({
    name: option.label,
    value: option,
    selected: option.selected,
  })),
);

const newChange = (value: any) => {
  const elements = value?.newElements || [];
  const selectedElements = elements.filter((element: any) => element.selected);
  const values = selectedElements.map((element: any) => element.value.id);
  emit('change', values);
};

const toggle = () => {
  isActive.value = !isActive.value;
};

const close = () => {
  isActive.value = false;
};
</script>

<style scoped src="./smart-recruiters-filter" />
